export default {
    init() {
    // JavaScript to be fired on the single products pages

        //Fullscreen Image Modal on Button Click
        let fullScreenImageBtn = document.querySelector('button.slider-for__image__full-screen');
        let videoPlayBtn = document.querySelector('.products-info__slider button.media-btn');
        let fullScreenModalImage = document.querySelector('#fullScreenProducts img');
        let fullScreenModalVideo = document.querySelector('#fullScreenProducts video');
        let videoSrc = null;
        let embedSrc = null;

        function showVideoFile(video) {
            // If a video hide the img tag and display video tag
            $('#fullScreenProducts img').css('display', 'none');
            $('#fullScreenProducts video').css('display', 'block');
            if($('#fullScreenProducts iframe')) {
                ($('#fullScreenProducts iframe')).css('display', 'none');
            }

            //Get source of original video
            videoSrc = video;

            //Update source of modal video
            fullScreenModalVideo.setAttribute('src', videoSrc);
        }

        function showVideoEmbed() {
            // If a video hide the img tag and display video tag
            $('#fullScreenProducts img').css('display', 'none');
            $('#fullScreenProducts video').css('display', 'none');
            ($('#fullScreenProducts iframe')).css('display', 'block');

            //Get embed source
            embedSrc = $('#kcar-iframe iframe');

            //Update modal source
            $('#fullScreenProducts .modal-dialog .modal-content .modal-body').append(embedSrc);
        }

        if(fullScreenImageBtn){
            fullScreenImageBtn.addEventListener('click', () => {
                let currentActiveImage = document.querySelector('.products-info__slider .slick-current > img');
                //let currentActiveVideo = document.querySelector('.products-info__slider .slick-current > video > source');
                let currentActiveSlide = document.querySelector('.products-info__slider .slick-current');
                //If Upload
                if(currentActiveSlide.dataset.type.includes('video')) {
                    showVideoFile(currentActiveImage.dataset.video) 
                }
                //If Embed
                else if(currentActiveSlide.dataset.type.includes('embed')) {
                    showVideoEmbed();
                }
                //If image
                else {
                    // If an image hide the video tag and display image tag
                    $('#fullScreenProducts img').css('display', 'block');
                    $('#fullScreenProducts video').css('display', 'none');
                    if($('#fullScreenProducts iframe')) {
                        ($('#fullScreenProducts iframe')).css('display', 'none');
                    }

                    //Get source of original image
                    let fullSizeSrc = currentActiveImage.dataset.fullSizeImage;

                    //Update source of modal image
                    fullScreenModalImage.src = fullSizeSrc;
                }
            });

            //Open the modal when play button overlaying video is clicked
            if(videoPlayBtn){
                videoPlayBtn.addEventListener('click', () => {  
                    let currentActiveImage = document.querySelector('.products-info__slider .slick-current > img');
                    let currentActiveSlide = document.querySelector('.products-info__slider .slick-current');
                    if(currentActiveSlide.dataset.type.includes('video')) {
                        showVideoFile(currentActiveImage.dataset.video);
                    } else if (currentActiveSlide.dataset.type.includes('embed')){
                        showVideoEmbed();
                    }
                });
            }
            
        }

        //When the modal is closed then stop the video
        $('#fullScreenProducts').on('hide.bs.modal', function() {
            setTimeout(function() {
                fullScreenModalVideo.pause();
            }, 500);
        });

        //products Main Carousel
        $('.products-info__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.products-info__slider-nav',
            autoplay: false,
        });

        // products Mini Carousel
        $('.products-info__slider-nav').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.products-info__slider',
            dots: false,
            autoplay: false,
            centerMode: false,
            focusOnSelect: true,
            infinite: true,
            swipeToSlide: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            }],
        });



    },
    finalize() {
      // JavaScript to be fired on the single products pages, after the init JS
    },
  };
  

    
